import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Support from './Support';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DeleteAccount from './DeleteAccount';
import Policy from './Policy';
import Terms from './Terms';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/support" element={<Support />} />
        <Route path="/deleteaccount" element={<DeleteAccount />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/terms" element={<Terms />} />

      </Routes>
    </Router>
  </React.StrictMode>
);
